// PageHeader.tsx — back button + "Post" title for the post-detail page.
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { IconButton } from '@/ui';

export interface PageHeaderProps { title?: string; }

const Row = styled.div`
  display: flex; align-items: center; gap: 12px; margin-bottom: 4px;
`;
const Title = styled.h1`
  margin: 0; font-family: ${({ theme }) => theme.font.display}; font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize.lg}; color: ${({ theme }) => theme.color.textPrimary};
`;

export function PageHeader({ title = 'Post' }: PageHeaderProps) {
  const navigate = useNavigate();
  function back() {
    if (window.history.length > 1) navigate(-1);
    else navigate('/');
  }
  return (
    <Row>
      <IconButton icon="arrow-left" label="Back" onClick={back} />
      <Title>{title}</Title>
    </Row>
  );
}
